/** How a contract violation reads on every surface that shows one. */

import type { z } from 'zod';

import type { ContractViolation } from '@/types/contract';
import { ViolationKind } from '@/types/contract';

/** Every loud surface says why it is there, so whoever is testing need not ask. */
export const LOUD_SCHEMA_ERRORS_NOTE =
    'Shown because LOUD_SCHEMA_ERRORS is on for this deployment. Production runs with it off.';

function getIssuePath(issue: z.core.$ZodIssue): string {
    return issue.path.map(String).join('.') || '(root)';
}

/** One issue: the path that broke, and how. */
export function getIssueText(issue: z.core.$ZodIssue): string {
    return `${getIssuePath(issue)} ${issue.message}`;
}

/** One line: where the violation came from, and what broke. */
export function getViolationText(violation: ContractViolation): string {
    switch (violation.kind) {
        case ViolationKind.UnknownFrame:
            return `${violation.endpoint}: unknown frame type "${violation.frameType}"`;
        case ViolationKind.Mismatch: {
            const where = violation.path === undefined
                ? violation.endpoint
                : `${violation.endpoint} at ${violation.path.map(String).join(' > ')}`;
            const what = violation.issues.map(getIssueText).join('; ');
            return `${where}: ${what}`;
        }
    }
}
